/* eslint-disable @typescript-eslint/no-namespace */
import { type ReactNode, type DOMAttributes } from 'react'
import Script from 'next/script'

export interface AfterpayPlacementProps {
  priceInDollars: number
  size: 'xs' | 'sm' | 'md' | 'lg'
  isOptionLabel?: boolean
}
type CustomEvents<K extends string> = {
  [key in K]: (event: CustomEvent) => void
}

type CustomElement<T, K extends string> = Partial<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-redundant-type-constituents
  T & DOMAttributes<T> & { children: any } & CustomEvents<`on${K}`>
>

declare global {
  namespace JSX {
    interface IntrinsicElements {
      ['afterpay-placement']: CustomElement<ReactNode, ''>
    }
  }
}

export const AfterpayPlacement = ({
  priceInDollars,
  size,
  isOptionLabel,
}: AfterpayPlacementProps) => {
  return (
    <>
      <Script
        src='https://js.afterpay.com/afterpay-1.x.js'
        data-analytics-enabled
        data-min='1'
        data-max='3000'
        strategy='lazyOnload'
      />
      <div className='text-sm text-dark'>
        <afterpay-placement
          data-testid='afterpay-forecast'
          data-locale='en_AU'
          data-currency='AUD'
          data-size={size}
          data-amount={priceInDollars}
          {...(isOptionLabel && {
            'data-logo-type': 'none',
            'data-payment-amount-is-bold': true,
            'data-intro-text': 'In',
            'data-show-interest-free': false,
            'data-show-with': false,
          })}
        />
      </div>
    </>
  )
}
